app.controller("StudentRegistrationRegisterController", [
    "$scope", "Users", "Students", "StaticData", "ProgramService", "toastr", "$state", "$stateParams", "$uibModal", "$http", "usSpinnerService",
    function ($scope, Users, Students, StaticData, ProgramService, toastr, $state, $stateParams, $uibModal, $http, usSpinnerService) {
        $scope.format = "dd-MM-yyyy";
        $scope.semesters = _.range(1, 15);
        $scope.semester = '1';

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        function load() {
            usSpinnerService.spin("root");
            Users.profile($stateParams.studentId).then(function (student) {
                if (!student.user.photo) student.user.defaultPhoto = "img/no_image.jpg";
                $scope.student = student;
                $scope.email = student.user.email;
                $scope.phone = student.user.phone;
                $scope.physicalAddress = student.user.physicalAddress;
                $scope.legalAddress = student.user.legalAddress;
                $scope.nationality = student.user.nationality;
                $scope.citizenship = student.user.citizenship;
                $scope.gender = student.user.gender;
                $scope.birthDate = student.user.birthDate ? new Date(student.user.birthDate) : undefined;
                $scope.birthPlace = student.user.birthPlace;
                $scope.workPlace = student.info.workPlace;
                $scope.workPosition = student.info.workPosition;
                $scope.school = student.info.school;
                $scope.graduationYear = student.info.graduationYear;
                $scope.militaryState = student.info.militaryState;
                $scope.fileName = student.info.militaryDocFileName;
                $scope.socialState = student.info.socialState;
                $scope.faculty = student.info.faculty;
                $scope.achievement = student.info.achievement;
                $scope.infoSource = student.info.infoSource;
                $scope.certificateDate = student.info.certificateDate ? new Date(student.info.certificateDate) : undefined;
                $scope.fileNameCert = student.info.certificateFileName;

                if (student.program) {
                    ProgramService.fetchOne(student.program).then(function (data) {
                        $scope.chosenProgram = data;
                        usSpinnerService.stop("root");
                    })
                } else {
                    usSpinnerService.stop("root");
                }
            });

        }

        load();

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            return ProgramService.list({query: name}).then(function (data) {
                return data.docs;
            });
        };

        $scope.changePhoto = function (user, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "ChangeImageFromAdminController",
                templateUrl: _pb + 'parameters/changeImage.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    user: function () {
                        return user;
                    }
                }
            }).result
                .then(function (result) {
                    $scope.student.user.photo = result.path;
                }, function () {

                });
        };

        $scope.uploadImage = function (files, field) {
            $scope.file = files[0];
            if (_.includes(field, 'certificate')) $scope.fileNameCert = $scope.file.name;
            else $scope.fileName = $scope.file.name;
            var fd = new FormData();
            fd.append('file', $scope.file);
            fd.append('student', $scope.student._id);
            fd.append('field', field);
            $http.post('/file/' + field + '/add', fd, {
                headers: {'Content-Type': undefined}
            }).then(function (response) {
                if (field === 'info.militaryDoc') {
                    $scope.student.info.militaryDoc = response.data.path;
                } else if (field === 'info.certificate.file') {
                    $scope.student.info.certificate.file = response.data.path;
                }
            })
        };

        $scope.getUsers = function (name) {
            if (name.length < 1) {
                return [];
            }
            return Users.list({
                query: name
            }).then(function (data) {
                return data.docs
            });
        };

        $scope.open1 = function () {
            $scope.popup1.opened = true;
        };

        $scope.open2 = function () {
            $scope.popup2.opened = true;
        };

        StaticData.getItemsByKey("gender").then(function (gender) {
            $scope.genders = [{name: "სქესი"}].concat(gender);
            $scope.genderMap = _.keyBy($scope.genders, '_id');
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        StaticData.getItemsByKey("military_state").then(function (militaryStates) {
            $scope.militaryStates = [{name: "სამხედრო ვალდებულება"}].concat(militaryStates);
            $scope.militaryStatesMap = _.keyBy($scope.militaryStates, '_id');
        });

        StaticData.getItemsByKey("info_source").then(function (infoSources) {
            $scope.infoSources = [{name: "საიდან გაიგეთ უნივერსიტეტის შესახებ"}].concat(infoSources);
            $scope.infoSourcesMap = _.keyBy($scope.infoSources, '_id');
        });

        StaticData.getItemsByKey("social_statuses").then(function (socialStatuses) {
            $scope.socialStatuses = [{name: "სოციალური სტატუსი"}].concat(socialStatuses);
            $scope.socialStatusesMap = _.keyBy($scope.socialStatuses, '_id');
        });

        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            clearText: "წაშლა",
            closeText: "დახურვა",
            currentText: "დღეს",
            startingDay: 1
        };

        $scope.programChanged = function () {
            if ($scope.chosenProgram._id) {
                $scope.faculty = $scope.chosenProgram.faculty;
            }
        };

        $scope.register = function () {
            var requestData = {
                student: {
                    _id: $stateParams.studentId,
                    program: $scope.chosenProgram ? $scope.chosenProgram._id : '',
                    info: {
                        faculty: $scope.chosenProgram ? $scope.chosenProgram.faculty : '',
                        infoSource: $scope.infoSource,
                        militaryState: $scope.militaryState,
                        socialStatus: $scope.socialStatus,
                        workPlace: $scope.workPlace,
                        workPosition: $scope.workPosition,
                        school: $scope.school,
                        graduationYear: $scope.graduationYear,
                        certificate: {
                            date: $scope.certificateDate
                        },
                        achievement: $scope.achievement
                    }
                },
                user: {
                    _id: $scope.student.user._id,
                    email: $scope.email,
                    phone: $scope.phone,
                    birthDate: $scope.birthDate,
                    birthPlace: $scope.birthPlace,
                    gender: $scope.gender,
                    citizenship: $scope.citizenship,
                    nationality: $scope.nationality,
                    physicalAddress: $scope.physicalAddress,
                    legalAddress: $scope.legalAddress
                }
            };

            // return console.log(requestData);
            Students.register(requestData).then(function () {
                toastr.success('', 'რეგისტრაცია  წარმატებით დასრულდა');
                window.open('student/register/form/' + $scope.student._id);
                $state.go('admin.student-registration');
            }).catch(function (err) {
                if (err.status === 400) {
                    toastr.error('', 'მიმდინარე სტუდენს უკვე აქვს სტუდენტის აქტიური პროფილი.');
                }
            });
        };
    }
]);
